import { getSignUpDisabledFields, getParsedAddress, getEmptyLivingAddress, canRegisterAsBorrower } from "../../helpers/signUp";

const state = {
    msiData: {},
    signUpDisabledFields: {},
    profile: {},
    refreshToken: ''
};

const actions = {
    async getMsiProfile(context, code) {
        context.dispatch('loading', true);

        try {
            const response = await window.$httpService.msi.getMsiProfile(code);

            const msiUserData = response.data;
            const contact = response.data.contact || {};
            const phone_number = contact.phoneSMSVerification || contact.phones?.[0] || '';
            const email = contact.emails?.[0];
            const address_str = getParsedAddress(response.data);
            const extraFields = {
                codeword: '',
                otp: '',
                password: '',
                living_address: getEmptyLivingAddress(),
                role: canRegisterAsBorrower(msiUserData) ? 'borrower' : 'lender'
            };
            const payload = {...msiUserData, phone_number, email, address_str, ...extraFields};

            const signUpDisabledFields = getSignUpDisabledFields(payload);
            context.commit('setSignUpDisabledFields', signUpDisabledFields);

            context.commit('setMsiData', payload);
            
            context.dispatch('loading', false);
        } catch (error) {
            context.dispatch('loading', false);
            window.kapystaRouter.push({ name: 'SignIn' });
        }
    },
    async signUp(context, data) {
        const payload = new FormData();

        payload.append('login', data.signUpData.login);
        payload.append('password', data.signUpData.password);

        for (let fieldName in data.userData) {
            if (data.userData[fieldName]) {
                payload.append(`${fieldName}`, JSON.stringify(data.userData[fieldName]));
            }
        }

        for (let fileName in data.files) {
            if (data.files[fileName]) {
                payload.append(`${fileName}`, data.files[fileName]);
            }
        }

        payload.append('eSign', ' ');

        try {
            const response = await window.$httpService.msi.signUp(payload);

            console.log(response.data);
        } catch (error) {
            window.kapystaRouter.push({ name: 'SignIn' });
        }
    },
    async signIn(context, payload) {
        try {
            const response = await window.$httpService.auth.signIn(payload);
            const token = response.data.token;
            await localStorage.setItem('token', token);
            
            window.kapystaRouter.push({ name: 'profile' });
        } catch (error) {
            console.log(error);
        }
    },
    async purgeAuth(context) {
        await localStorage.removeItem('token');
        await context.commit('setProfile', {});
        window.kapystaRouter.push({ name: 'main' }).catch(() => {});
    },
    async purgeProfile(context) {
        await context.commit('setProfile', {});
    },
    async getProfile(context) {
        context.dispatch('loading', true);

        try {
            const response = await window.$httpService.auth.getProfile();

            context.commit('setProfile', response.data);
            context.dispatch('loading', false);
        } catch (error) {
            await context.dispatch('purgeAuth');
            context.dispatch('loading', false);
        }
    },
    async refreshToken(context) {
        try {
            const response = await window.$httpService.auth.refreshToken();
            response.json().then(data => {
                if(data?.token) {
                    localStorage.setItem('token', data.token);
                }
            });
        } catch (error) {
            context.dispatch('purgeAuth');
        }
    },
    async updateProfile(context) {
        try {
            const response = await window.$httpService.auth.getProfile();
      
            context.commit('setProfile', response.data);
          } catch (error) {
            context.dispatch('purgeAuth');
          }
    },
    async checkAuth(context) {
        const isAuthorizated = !!localStorage.getItem('token');

        if (isAuthorizated) {
            await context.dispatch('getProfile');
        }
    }
};

const mutations = {
    setMsiData(state, data) {
        state.msiData = data;
    },
    setSignUpDisabledFields(state, data) {
        state.signUpDisabledFields = data;
    },
    setProfile(state, data) {
        state.profile = data;
    }
};

const getters = {
    msiData(state) {
        return state.msiData;
    },
    signUpDisabledFields(state) {
        return state.signUpDisabledFields;
    },
    profile(state) {
        return state.profile;
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}